import useSWR from 'swr'
import API from '../../utils/api'
import { getPersistData } from '../../app/hooks/persist'
import { useToken } from 'app/hooks'

const KEY = '/system/accesspath?page=1&maxData=99999999' // (1) 방문 경로 목록 조회

let swrData: any = getPersistData(KEY)

export function usePathList() {
	const { data: token } = useToken()
	const { data, mutate } = useSWR<any>(
		KEY,
		async () => {
			const response = await API.get(KEY, token + '', {})
			swrData = response.result?.result?.list

			return swrData
		},
		{ revalidateOnFocus: true }
	)

	return {
		pathList: data,
		mutate: (value?: any) => {
			if (value != undefined) {
				swrData = value
			}
			return mutate()
		},
	}
}